<p-toast position="top-right" />
<p-toast position="top-right" key="chat" *transloco="let t" [style]="{ 'width': '22rem' }">
  <ng-template let-message pTemplate="message">
    <div class="flex items-center gap-2 w-full">
      <i class="pi pi-envelope" style="color: var(--p-primary-color); font-size: 1.25rem; flex-shrink: 0; align-self: start; margin-top: 0.15rem"></i>
      <div style="min-width: 0; flex: 1; overflow: hidden">
        <div style="font-size: 0.85rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <span style="color: var(--p-text-secondary-color)">{{ message.summary }}</span>
          <span class="font-bold">{{ message.data.sender }}</span>
        </div>
        <div style="color: var(--p-text-secondary-color); font-size: 0.8rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 0.15rem">{{ message.detail }}</div>
      </div>
      <p-button
        [label]="t('chat.reply')"
        size="small"
        icon="pi pi-reply"
        class="shrink-0"
        (click)="openThread(message.data.threadId)" />
    </div>
  </ng-template>
</p-toast>
<div class="min-h-screen bg-surface-ground">
  <router-outlet />
</div>
@if (!isLayoutlessRoute) {
  <app-consent-banner />
}
